import React, {useEffect, useState, useRef} from "react";
import "./MateChannel.css";
import Card from "react-bootstrap/Card";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSpinner} from "@fortawesome/free-solid-svg-icons";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import {faFloppyDisk} from "@fortawesome/free-regular-svg-icons";

window._channelStarted = window._channelStarted || {};

function MateChannel({bond, mate, channelId}) {
    const [channelInfo, setChannelInfo] = useState(null);
    const [isSaving, setIsSaving] = useState(false);
    const nameRef = useRef();
    const labelRef = useRef();
    const templateRef = useRef();
    const propertiesRef = useRef();


    useEffect(() => {
        window._channelStarted[mate.id] = window._channelStarted[mate.id] || {};
        if (!window._channelStarted[mate.id][channelId]) {
            window._channelStarted[mate.id][channelId] = true;
            if (channelInfo === null) setTimeout(updateChannelInfo, 200 * parseInt(channelId))
        }
    }, [channelInfo]);

    function updateChannelInfo() {
        mate.get("channels/" + channelId).then(info => {
            if (info && info.properties !== undefined) {
                setChannelInfo(info);
                if (nameRef.current) {
                    nameRef.current.value = info.name || '';
                    labelRef.current.value = info.label || '';
                    propertiesRef.current.value = JSON.stringify(info.properties, null, 2);
                    templateRef.current.value = info.template;
                }
                window._channelStarted[mate.id][channelId] = false;
            } else {
                setTimeout(updateChannelInfo, 100 + Math.random() * 1000);
            }
        });
    }

    function saveChannelInfo() {
        let name = nameRef.current.value;
        let label = labelRef.current.value;
        const properties = JSON.parse(propertiesRef.current.value || '{}');
        name = name || label
        label = label || name;
        let updatePayload = {"name": name, "label": label, "properties": properties}
        updatePayload["template"] = templateRef.current.value || channelInfo.template;
        setIsSaving(true)
        mate.patch(`channels/${channelId}`, updatePayload).then(() => {
            updateChannelInfo();
        }).catch(err => {
            console.error('Error saving channel info:', err);
        }).finally(() => {
            setIsSaving(false);
        });
    }


    return (<Card className={"mateChannelCard"}>
        <Card.Header className={"fs-5"}>
            <strong
                className={"channelIdLabel"}>{channelId}</strong> {channelInfo ? `${channelInfo.name} (${channelInfo.label})` : ''}
            <Button className={"float-end"} variant={"outline-secondary"} disabled={isSaving} onClick={saveChannelInfo}>
                <FontAwesomeIcon icon={isSaving ? faSpinner : faFloppyDisk}
                                 className={isSaving ? "fa-spin" : ""}/></Button>
        </Card.Header>
        <Card.Body>
            {channelInfo ? (<div className="channel-info">
                <Form>
                    <Form.Group className="mb-2">
                        <Form.Label>Name</Form.Label>
                        <Form.Control ref={nameRef} defaultValue={channelInfo.name}/>
                    </Form.Group>
                    <Form.Group className="mb-2">
                        <Form.Label>Label</Form.Label>
                        <Form.Control ref={labelRef} defaultValue={channelInfo.label}/>
                    </Form.Group>
                    <Form.Group className="mb-2">
                        <Form.Label>Template</Form.Label>
                        <Form.Control ref={templateRef} defaultValue={channelInfo.template}/>
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>Properties</Form.Label>
                        <Form.Control as="textarea" rows={4} ref={propertiesRef}
                                      defaultValue={JSON.stringify(channelInfo.properties, null, 2)}/>
                    </Form.Group>
                </Form>
            </div>) : (<div><FontAwesomeIcon icon={faSpinner} className={"fa-spin"}/></div>)}
        </Card.Body>
    </Card>);
}

export default MateChannel;

